import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import { ThumbsUp, ThumbsDown } from "lucide-react-native";
import {
  QuestionLayout,
  SquareOptionButton,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useAllergies } from "../AllergiesContext";
import type { AllergiesStackParamList } from "../AllergiesNavigator";

export function AllergiesIntroScreen() {
  const t = useTranslations();
  const { state, updateState } = useAllergies();
  const navigation = useNavigation<NavigationProp<AllergiesStackParamList>>();

  const selection: "yes" | "no" | null =
    state.hasAllergies === null ? null : state.hasAllergies ? "yes" : "no";

  const handleSave = () => {
    if (selection === "yes") {
      navigation.navigate("AllergiesDetails");
    } else {
      // User answered "No" - navigate to complete screen
      navigation.navigate("AllergiesComplete");
    }
  };

  return (
    <QuestionLayout
      title={t("med_history.medical.allergies.intro_title")}
      subtitle={t("med_history.medical.allergies.intro_subtitle")}
      onBack={() => navigation.goBack()}
      onSave={handleSave}
      saveDisabled={!selection}
      saveLabel={t("med_history.medical.shared.continue")}
    >
      <View style={styles.optionsContainer}>
        <SquareOptionButton
          icon={ThumbsUp}
          label={t("med_history.shared.yes")}
          isSelected={selection === "yes"}
          onPress={() => updateState({ hasAllergies: true })}
          iconSize={24}
          containerSize={48}
          labelSize="lg"
        />
        <SquareOptionButton
          icon={ThumbsDown}
          label={t("med_history.shared.no")}
          isSelected={selection === "no"}
          onPress={() => updateState({ hasAllergies: false })}
          iconSize={24}
          containerSize={48}
          labelSize="lg"
        />
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  optionsContainer: {
    flexDirection: "row",
    gap: 12,
    marginBottom: 40,
    width: "100%",
  },
});

export default AllergiesIntroScreen;
